import { SituacaoEleicaoEnumType } from '../types/enums/SituacaoEleicaoEnumType';

const SituacaoEleicaoEnum: { [key: string]: any } = Object.freeze({
  CANCELADA: {
    badge_class: 'bg-danger',
    color_class: 'danger',
    descricao: 'label.cancelada',
    key: 'CANCELADA',
    text_color: 'text-danger',
  },
  NAO_PUBLICADA: {
    badge_class: 'bg-secondary',
    color_class: 'secondary',
    descricao: 'label.nao_publicada',
    key: 'NAO_PUBLICADA',
    text_color: 'text-secondary',
  },
  PUBLICADA: {
    badge_class: 'bg-success',
    color_class: 'success',
    descricao: 'label.publicada',
    key: 'PUBLICADA',
    text_color: 'text-success',
  },
  findByKey: (key: string) => {
    let objFound = SituacaoEleicaoEnum.getAll().find((obj: SituacaoEleicaoEnumType) => obj.key === key);
    if (objFound) {
      return objFound;
    }
    throw Error(`Chave ${key} não foi encontrada na enum.`);
  },
  getAll: () =>
    Object.keys(SituacaoEleicaoEnum)
      .filter((genericProperty) => typeof SituacaoEleicaoEnum[genericProperty] === 'object')
      .map((indexFound) => SituacaoEleicaoEnum[indexFound]),
});

export default SituacaoEleicaoEnum;
